import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Paper, Card, CardText, RaisedButton, Table, TableBody, TableRow,
  TableRowColumn, CircularProgress, Dialog, FlatButton
} from "material-ui";
import urlHelper from "../../../helpers/urlHelper";
import DetalleSolicitudSE from "./DetalleSolicitud";
import { ValidarReplicaCentrosAtencionHomologos, ValidarReplicaSolicitudEnCurso, ValidarReplicaPrestHomologas, AplicarReplicarSolicitud, ObtenerSolicitudes } from "../FiltroBusqueda/actions";

class ResolucionSolicitudSE extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalValidacion: false,
      loadingValidacionSolicitudEnCurso: null,
      loadingValidacionCentrosAtencion: null,
      loadingValidacionIdsHomologos: null,
      centrosAtencionNoEncontrados: [],
      isReplicated: false,
      replicating: false,
      showSuccessReplica: false,
    };
  }
  componentWillMount() {
  }

  ReplicarSolicitud = () => {
    this.setState({ modalValidacion: true });

    // Validar solicitud
    this.props.dispatch(ValidarReplicaCentrosAtencionHomologos(
      this.props.detalleSolicitud.IdSolicitud,
      (lvca, CANoEncontrados) => {
        this.setState({ loadingValidacionCentrosAtencion: lvca, centrosAtencionNoEncontrados: CANoEncontrados });
        if (lvca) {
          this.ValidarEtapa2();
        }
      },
      () => {
        this.setState({ loadingValidacionCentrosAtencion: false, centrosAtencionNoEncontrados: [] });
      }
    ));
  }

  ValidarEtapa2 = () => {
    this.props.dispatch(ValidarReplicaSolicitudEnCurso(
      this.props.detalleSolicitud.IdSolicitud,
      (lvsc) => {
        this.setState({ loadingValidacionSolicitudEnCurso: lvsc });
      },
      () => {
        this.setState({ loadingValidacionSolicitudEnCurso: false });
      }
    ));
    /*this.props.dispatch(ValidarReplicaPrestHomologas(
      this.props.detalleSolicitud.IdSolicitud,
      (lvih) => {
        this.setState({ loadingValidacionIdsHomologos: lvih });
      },
      () => {
        this.setState({ loadingValidacionIdsHomologos: false });
      }
    ));*/
  }

  AplicarReplicarSolicitud = () => {
    const { IdSolicitud, IdSolicitudEspecial } = this.props.detalleSolicitud;
    const { isapre } = this.props;

    // Permite saber si se encuentra en el proceso de replicación
    this.setState({ replicating: true });

    this.props.dispatch(AplicarReplicarSolicitud(IdSolicitud, IdSolicitudEspecial, isapre,
      () => {
        this.setState({ isReplicated: true, showSuccessReplica: true, replicating: false });
        this.props.dispatch(ObtenerSolicitudes());
      },
      () => this.setState({ isReplicated: false, showSuccessReplica: true, replicating: false })
    ));
  }

  ModalSolicitudReajuste = () => {
    urlHelper.RedirectTo("SolicitudesRealizadas");
  }

  BColorSegunValidacion = (validacion) => {
    if (validacion === true) {
      return "#dcf7dc";
    }
    if (validacion === false) {
      return "#f7dcdd";
    }
    return "";
  }

  IconSegunValidacion = (validacion) => {
    if (validacion === true) {
      return <i className="material-icons">done</i>;
    }
    if (validacion === false) {
      return <i className="material-icons">clear</i>;
    }
    return <CircularProgress size={25} />;
  }

  handleCloseDialog = () => this.setState({ showSuccessReplica: false });

  render() {
    const lvsc = this.state.loadingValidacionSolicitudEnCurso;
    const lvca = this.state.loadingValidacionCentrosAtencion;
    const lvih = this.state.loadingValidacionIdsHomologos;

    const { isReplicated, replicating, showSuccessReplica } = this.state;

    return (

      <div style={{ width: "100%", fontSize: "13px" }}>
        <Card zDepth={0} style={{ padding: 0 }}>
          <CardText style={{ paddingBottom: 0 }}>
            <div className="row" style={{ paddingBottom: 0 }}>
              <div className="col-12">
                <DetalleSolicitudSE
                  detalleSolicitud={{
                    IdSolicitud: this.props.detalleSolicitud.IdSolicitud,
                    FechaCreacion: this.props.detalleSolicitud.FechaCreacion,
                    EstadoSE: this.props.detalleSolicitud.EstadoSE,
                    IdEstadoSE: this.props.detalleSolicitud.IdEstadoSE,
                    IdSolicitudHomologa: this.props.detalleSolicitud.IdSolicitudHomologa,
                    EsReplicacion: false,
                  }}
                />
              </div>
              {this.props.detalleSolicitud.IdSolicitudEspecialHijo > 0 ?
                <div className="col-12">
                  <DetalleSolicitudSE
                    detalleSolicitud={{
                      IdSolicitud: this.props.detalleSolicitud.IdSolicitudHijo,
                      FechaCreacion: this.props.detalleSolicitud.FechaCreacionHijo,
                      EstadoSE: this.props.detalleSolicitud.EstadoSEHijo,
                      IdEstadoSE: this.props.detalleSolicitud.IdEstadoSEHijo,
                      IdSolicitudHomologa: this.props.detalleSolicitud.IdSolicitudHomologa,
                      EsReplicacion: true,
                    }}
                  />
                </div>
                : null}
              {this.props.detalleSolicitud.IdSolicitudEspecialPadre > 0 ?
                <div className="col-12">
                  <DetalleSolicitudSE
                    detalleSolicitud={{
                      IdSolicitud: this.props.detalleSolicitud.IdSolicitudPadre,
                      FechaCreacion: this.props.detalleSolicitud.FechaCreacionPadre,
                      EstadoSE: this.props.detalleSolicitud.EstadoSEPadre,
                      IdEstadoSE: this.props.detalleSolicitud.IdEstadoSEPadre,
                      IdSolicitudHomologa: this.props.detalleSolicitud.IdSolicitudHomologa,
                      EsReplicacion: true,
                    }}
                  />
                </div>
                : null}

              {this.props.prestadorPuedeReplicar &&
                this.props.detalleSolicitud.IdEstadoSE === 53 &&
                this.props.detalleSolicitud.IdEstadoSEPadre !== 53 &&
                this.props.detalleSolicitud.IdEstadoSEHijo !== 53 ?
                (
                  <div className="col-12">
                    <Paper zDepth={1} rounded={false} width="100%" style={{ margin: "10px 0px", width: "100%", padding: "10px 5px" }} >
                      <div>
                        ¿Desea replicar la solicitud en isapre&nbsp;
                        <strong>{this.props.isapre === "B" ? "VidaTres" : "Banmedica"}</strong>?
                        <RaisedButton
                          label="Replicar Solicitud"
                          onClick={this.ReplicarSolicitud}
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                          disabled={!this.props.usuarioPuedeReplicar}
                        />
                        {!this.props.usuarioPuedeReplicar ?
                          <p style={{ color: "#a80000" }}>
                            Permisos insuficientes para replicar solicitud. Contacte a su administrador.
                          </p>
                          : null}

                        {this.state.modalValidacion ?
                          <div style={{ marginTop: 10 }}>
                            <Table
                              selectable={false}
                              multiSelectable={false}
                              style={{ width: 800, margin: "auto" }}
                            >
                              <TableBody displayRowCheckbox={false}>

                                <TableRow style={{ backgroundColor: this.BColorSegunValidacion(lvca) }}>
                                  <TableRowColumn>Validación Centros Atención replicados</TableRowColumn>
                                  <TableRowColumn style={{ width: 50, padding: 0 }}>
                                    {this.IconSegunValidacion(lvca)}
                                  </TableRowColumn>
                                  <TableRowColumn style={{ whiteSpace: "normal" }}>
                                    {lvca === false ?
                                      <span>
                                        No se encontraron los centros de atención a replicar en :&nbsp;
                                        <strong>{this.state.centrosAtencionNoEncontrados.join(", ")}</strong><br></br>
                                        Favor comunicarse con Convenios Médicos.
                                      </span>
                                      : null}
                                  </TableRowColumn>
                                </TableRow>

                                {this.state.centrosAtencionNoEncontrados.length === 0 ?
                                  <TableRow style={{ backgroundColor: this.BColorSegunValidacion(lvsc) }}>
                                    <TableRowColumn>Validación solicitud en curso</TableRowColumn>
                                    <TableRowColumn style={{ width: 50, padding: 0 }}>
                                      {this.IconSegunValidacion(lvsc)}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ whiteSpace: "normal" }}>
                                      {lvsc === false ?
                                        <span>
                                          Ya posee una solicitud, con al menos una prestacion en curso, en la isapre a replicar.
                                        </span>
                                        : null}
                                      {lvsc === true ?
                                        <span>No posee solicitudes en curso en la isapre a replicar.</span>
                                        : null}
                                    </TableRowColumn>
                                  </TableRow>
                                  : null}

                                {/*this.state.centrosAtencionNoEncontrados.length === 0 ?
                                  <TableRow style={{ backgroundColor: this.BColorSegunValidacion(lvih) }}>
                                    <TableRowColumn>Validación prestaciones homologas</TableRowColumn>
                                    <TableRowColumn style={{ width: 50, padding: 0 }}>
                                      {this.IconSegunValidacion(lvih)}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ whiteSpace: "normal" }}>
                                      {lvih === false ?
                                        <span>
                                          No existen todas las prestaciones en la isapre a replicar
                                        </span>
                                        : null}
                                      {lvih === true ?
                                        <span>Todas las prestaciones a modificar o eliminar existen en la isapre a replicar</span>
                                        : null}
                                    </TableRowColumn>
                                  </TableRow>
                                      : null*/}

                              </TableBody>
                            </Table>
                            <div className="row justify-content-end" style={{ paddingTop: 10 }}>
                              <div className="col-3">
                                {
                                  !replicating ?
                                    !isReplicated ?
                                      <RaisedButton
                                        label="Aplicar replicación"
                                        onClick={this.AplicarReplicarSolicitud}
                                        secondary
                                        labelStyle={{ fontSize: "11px" }}
                                        overlayStyle={{ borderRadius: 5 }}
                                        rippleStyle={{ borderRadius: 5 }}
                                        style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                                        buttonStyle={{ borderRadius: 5 }}
                                        disabled={!(lvsc === true && lvca === true /*&& lvih === true*/)}
                                      />
                                      :
                                      <p>
                                        Ya ha replicado esta solicitud.
                                      </p>
                                    :
                                    <CircularProgress />
                                }
                              </div>
                            </div>
                          </div>
                          : null}
                      </div>
                    </Paper>
                  </div>
                )
                : null}
              <div className="col-12">
                <Paper zDepth={1} rounded={false} width="100%" style={{ margin: "10px 0px", width: "100%", padding: "10px 5px" }} >
                  <div className="row" style={{ paddingTop: 10 }}>
                    <div className="col-3">
                      <RaisedButton
                        label="Volver"
                        onClick={() => this.props.closeModal()}
                        secondary
                        labelStyle={{ fontSize: "11px" }}
                        overlayStyle={{ borderRadius: 5 }}
                        rippleStyle={{ borderRadius: 5 }}
                        style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                        buttonStyle={{ borderRadius: 5 }}
                      />
                    </div>
                  </div>
                </Paper>
              </div>
            </div>
          </CardText>
        </Card>

        <Dialog
          open={showSuccessReplica}
          modal
          actions={
            <FlatButton
              label="Cerrar"
              primary
              onClick={this.handleCloseDialog}
            />
          }
          style={{ width: "700px", fontSize: "12px" }}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={true}
          repositionOnUpdate={true}
          contentStyle={{ width: '90%', height: '90%' }}
        >
          {
            isReplicated ?
              'Se ha completa exitosamente la replicación de su carga masiva a la otra isapre.'
              :
              'Ocurrió un error al momento de realizar la replicación de su carga masiva'
          }
        </Dialog>
      </div>
    );
  }
}

ResolucionSolicitudSE.defaultProps = {
};

ResolucionSolicitudSE.propTypes = {
  dispatch: PropTypes.func.isRequired,
  detalleSolicitud: PropTypes.any.isRequired,
  closeModal: PropTypes.func.isRequired,
  isapre: PropTypes.string.isRequired,
  prestadorPuedeReplicar: PropTypes.bool.isRequired,
  usuarioPuedeReplicar: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  // detalleSolicitud: state.filtroBusquedaSE.detalleSolicitud,
  isapre: state.global.isapre,
  usuarioPuedeReplicar: state.replicarSolicitud.usuarioPuedeReplicar,
  prestadorPuedeReplicar: state.replicarSolicitud.prestadorPuedeReplicar,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ResolucionSolicitudSE);
